<template>
  <div class="rejected-offers container-fluid">
    <div class="row title-row">
      <div class="col-12">{{title}}</div>
    </div>
    <div class="row offers-row">
      <RejectedOffer class="col-12" v-for="(offer, index) in rejectedOffers" :class="{ last: index === rejectedOffers.length-1 }" :key="offer.offer.displayedOfferId ?? offer.offer.id" :offer="offer"></RejectedOffer>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import RejectedOffer from './mini-offers/RejectedOffer.vue'

export default {
  name: 'RejectedOffers',
  props: ['filterFunction', 'title'],
  components: {
    RejectedOffer
  },
  data () {
    return {
    }
  },
  computed: {
    rejectedOffers () {
      return this.submits.filter((offer) => offer.status !== 'Accepted' && (!this.filterFunction || this.filterFunction(offer.offer)))
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.rejected-offers {
  border: 1px solid #ebccd1;
  margin-bottom: 20px;
  border-radius: .25em;
  padding-bottom: 30px;
}
.rejected-offers .title-row {
  padding: 20px 0;
  border-bottom: 1px solid #ebccd1;
  color: #a94442;
  background-color: #f2dede;
  font-size: 18px;
}
.rejected-offer {
  border: 1px solid #ddd;
  margin: 15px 15px 5px 15px;
  width: calc(100% - 30px);
}
</style>
